import type { FC } from "react";
import "./ellipses.css";

export interface EllipsesLoaderProps {
  className?: string;
  contentContainerStyle?: string;
}

const EllipsesLoader: FC<EllipsesLoaderProps> = ({
  className = "",
  contentContainerStyle = "",
}) => {
  return (
    <div aria-label="Loading" className={`lds-ellipsis scale-75 ${className}`}>
      <div className={`bg-green ${contentContainerStyle}`} />
      <div className={`bg-green ${contentContainerStyle}`} />
      <div className={`bg-green ${contentContainerStyle}`} />
      <div className={`bg-green ${contentContainerStyle}`} />
    </div>
  );
};

export default EllipsesLoader;
